import { ImDownload3 } from "react-icons/im";
import resume from "../../assets/images/Lala Asgarova CV.pdf";
import "./Home.scss";
import { Link } from "react-scroll";
const Home = () => {
  return (
    <div className="home">
      <div className="text">
        <h1 data-aos="fade-up">
          Hi, I'm Lala <span>Asgarova</span>
        </h1>
        <h4 data-aos="fade-up" data-aos-duration="800">
          Software Developer
        </h4>
      </div>
      <div data-aos="fade-up" data-aos-duration="1000" className="cv">
        <a href={resume} download="Lala Asgarova CV.pdf">
          Download CV <ImDownload3 />
        </a>
      </div>
      <Link
        to="about"
        spy={true}
        smooth={true}
        offset={-100}
        duration={50}
        className="falling-arrow"
      >
        <span data-aos="fade-up"></span>
        <span data-aos="fade-up"></span>
        <span data-aos="fade-up"></span>
      </Link>
    </div>
  );
};

export default Home;
